// extracted by mini-css-extract-plugin
export var actions = "_ta-4";
export var item = "_ta-1";
export var price = "_ta-3";
export var quantity = "_ta-2";
export var table = "_ta-0";